import * as React from "react";
import SmartColumn from "../smart-column/SmartColumn";

const SmartColumnRoute: React.FC = () => {
  return (
    <div>
      <SmartColumn />
    </div>
  );
};

export default SmartColumnRoute;

